export default {
  props: ['error'],
  components: {
    Error404: () => import('~/components/layouts/error404'),
    Error500: () => import('~/components/layouts/error500')
  }
}
